import { BaseService } from "core/services";
import { InventoryCalculationCutbackRouteService } from "application/facility-order/services";

class InventoryCalculationCutbackService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new InventoryCalculationCutbackRouteService());
	}

	updateCutbackAdjustedQty(resource) {
		const url = this.routeService.updateCutbackAdjustedQty(resource);
		return this.apiClient.put(url, resource);
	}
	
	updateCutbackAdjustedQtyNewFlow(resource) {
		const url = this.routeService.updateCutbackAdjustedQtyNewFlow(resource);
		return this.apiClient.put(url, resource);
	}

	updateCutbackAdjustedQtyNikoFlow(resource) {
		const url = this.routeService.updateCutbackAdjustedQtyNikoFlow(resource);
		return this.apiClient.put(url, resource);
	}
}

export default InventoryCalculationCutbackService;